/** Auto-generated by `src/scripts/generate-icon-files.mjs`. Do not edit by hand. */

import type React from "react";
import type { PlaceholderIconProps } from "@/components/icons/icons-utils/icon-props";

import { Accessibility } from "../accessibility";
import { AddressBook } from "../address-book";
import { Administration } from "../administration";
import { AlertCircle } from "../alert-circle";
import { Archive } from "../archive";
import { ArrowBigUp } from "../arrow-big-up";
import { ArrowDown91 } from "../arrow-down91";
import { ArrowDownUp } from "../arrow-down-up";
import { ArrowDownWideShort } from "../arrow-down-wide-short";
import { ArrowDownZA } from "../arrow-down-za";
import { ArrowLeft } from "../arrow-left";
import { ArrowRight } from "../arrow-right";
import { ArrowRightFromLine } from "../arrow-right-from-line";
import { ArrowRotateLeft } from "../arrow-rotate-left";
import { ArrowRotateRight } from "../arrow-rotate-right";
import { ArrowUp19 } from "../arrow-up19";
import { ArrowUpArrowDown } from "../arrow-up-arrow-down";
import { ArrowUpAZ } from "../arrow-up-az";
import { ArrowUpDown } from "../arrow-up-down";
import { ArrowUpShortWide } from "../arrow-up-short-wide";
import { Badge } from "../badge";
import { Ban } from "../ban";
import { BarChart } from "../bar-chart";
import { BarsStaggered } from "../bars-staggered";
import { Baseline } from "../baseline";
import { Bell } from "../bell";
import { BellOff } from "../bell-off";
import { Bold } from "../bold";
import { Book } from "../book";
import { BookBookmark } from "../book-bookmark";
import { Bookmark } from "../bookmark";
import { BookOpenCover } from "../book-open-cover";
import { Books } from "../books";
import { Building2 } from "../building2";
import { Buildings } from "../buildings";
import { Calendar } from "../calendar";
import { CalendarDays } from "../calendar-days";
import { Cancel } from "../cancel";
import { Cancelled } from "../cancelled";
import { CaretSort } from "../caret-sort";
import { Cdc } from "../cdc";
import { CdcCancelled } from "../cdc-cancelled";
import { CdcDraft } from "../cdc-draft";
import { CdcInContract } from "../cdc-in-contract";
import { CdcPending } from "../cdc-pending";
import { CdcSent } from "../cdc-sent";
import { CdcSigned } from "../cdc-signed";
import { CdcSignedInContract } from "../cdc-signed-in-contract";
import { CdcValidated } from "../cdc-validated";
import { Certificate } from "../certificate";
import { ChartSimple } from "../chart-simple";
import { Check } from "../check";
import { ChevronDown } from "../chevron-down";
import { ChevronLeft } from "../chevron-left";
import { ChevronRight } from "../chevron-right";
import { ChevronRightDouble } from "../chevron-right-double";
import { ChevronsLeft } from "../chevrons-left";
import { ChevronsLeftRight } from "../chevrons-left-right";
import { ChevronsRight } from "../chevrons-right";
import { ChevronUp } from "../chevron-up";
import { ChevronUpDouble } from "../chevron-up-double";
import { ChevronLeftDouble } from "../chevron-left-double";
import { ChevronDownDouble } from "../chevron-down-double";
import { Circle } from "../circle";
import { CircleCheck } from "../circle-check";
import { CircleCheckBig } from "../circle-check-big";
import { CircleDashed } from "../circle-dashed";
import { CircleDot } from "../circle-dot";
import { CircleSmall } from "../circle-small";
import { CircleX } from "../circle-x";
import { CircleXmark } from "../circle-xmark";
import { City } from "../city";
import { ClearStyle } from "../clear-style";
import { Clock } from "../clock";
import { Close } from "../close";
import { Cloud } from "../cloud";
import { CloudArrowUp } from "../cloud-arrow-up";
import { CloudCheck } from "../cloud-check";
import { CloudExclamation } from "../cloud-exclamation";
import { Cog } from "../cog";
import { Coins } from "../coins";
import { Columns } from "../columns";
import { CompAlignCenter } from "../comp-align-center";
import { CompAlignLeft } from "../comp-align-left";
import { CompAlignRight } from "../comp-align-right";
import { Contract } from "../contract";
import { Copy } from "../copy";
import { CornerDownRight } from "../corner-down-right";
import { Create } from "../create";
import { Crop } from "../crop";
import { Cross2 } from "../cross2";
import { Dark } from "../dark";
import { Dash } from "../dash";
import { Database } from "../database";
import { DeleteMultiple } from "../delete-multiple";
import { DeleteSingle } from "../delete-single";
import { Description } from "../description";
import { DetailsView } from "../details-view";
import { DiamondExclamation } from "../diamond-exclamation";
import { DisplayModeCalendar } from "../display-mode-calendar";
import { DisplayModeGrid } from "../display-mode-grid";
import { DisplayModeList } from "../display-mode-list";
import { DisplayModeTable } from "../display-mode-table";
import { DisplayModeTimeline } from "../display-mode-timeline";
import { DisplayModeTree } from "../display-mode-tree";
import { DisplayPreferences } from "../display-preferences";
import { DollarSign } from "../dollar-sign";
import { DoorOpen } from "../door-open";
import { DotFilled } from "../dot-filled";
import { Download } from "../download";
import { DragHandle } from "../drag-handle";
import { Duration } from "../duration";
import { Edit } from "../edit";
import { Ellipsis } from "../ellipsis";
import { Email } from "../email";
import { Empty } from "../empty";
import { EmptySet } from "../empty-set";
import { EnableDrag } from "../enable-drag";
import { Envelope } from "../envelope";
import { Error } from "../error";
import { EuroSign } from "../euro-sign";
import { Event } from "../event";
import { EventLocation } from "../event-location";
import { EventType } from "../event-type";
import { ExclamationTriangle } from "../exclamation-triangle";
import { Expand } from "../expand";
import { Eye } from "../eye";
import { EyeClosed } from "../eye-closed";
import { EyeOff } from "../eye-off";
import { EyeSlash } from "../eye-slash";
import { Faculty } from "../faculty";
import { False } from "../false";
import { Fee } from "../fee";
import { File } from "../file";
import { FileContract } from "../file-contract";
import { FileInvoice } from "../file-invoice";
import { FileLines } from "../file-lines";
import { FileSignature } from "../file-signature";
import { FileSpreadsheet } from "../file-spreadsheet";
import { FileText } from "../file-text";
import { Filter } from "../filter";
import { FilterDelete } from "../filter-delete";
import { FilterSlash } from "../filter-slash";
import { FirstPage } from "../first-page";
import { Flag } from "../flag";
import { Folder } from "../folder";
import { Fullscreen } from "../fullscreen";
import { Globe } from "../globe";
import { GraduationCap } from "../graduation-cap";
import { Grid } from "../grid";
import { Grid2 } from "../grid2";
import { Grid3x3 } from "../grid3x3";
import { GripVertical } from "../grip-vertical";
import { Group } from "../group";
import { Hashtag } from "../hashtag";
import { HelpCircle } from "../help-circle";
import { Highlighter } from "../highlighter";
import { Home } from "../home";
import { HorizontalRule } from "../horizontal-rule";
import { Hourglass } from "../hourglass";
import { HourglassClock } from "../hourglass-clock";
import { Hyphen } from "../hyphen";
import { Image } from "../image";
import { ImageUp } from "../image-up";
import { InputNumeric } from "../input-numeric";
import { Invisible } from "../invisible";
import { Italic } from "../italic";
import { Key } from "../key";
import { Keyboard } from "../keyboard";
import { LastPage } from "../last-page";
import { LayerGroup } from "../layer-group";
import { Layers } from "../layers";
import { Layers2 } from "../layers2";
import { Layers3 } from "../layers3";
import { Layout } from "../layout";
import { LayoutTemplate } from "../layout-template";
import { LearningTree } from "../learning-tree";
import { LearningUnit } from "../learning-unit";
import { Light } from "../light";
import { Link } from "../link";
import { Link2 } from "../link2";
import { LinkSlash } from "../link-slash";
import { LinkValues } from "../link-values";
import { List } from "../list";
import { ListFilter } from "../list-filter";
import { ListOl } from "../list-ol";
import { ListTimeline } from "../list-timeline";
import { ListTree } from "../list-tree";
import { ListUl } from "../list-ul";
import { Loader2 } from "../loader2";
import { Loading } from "../loading";
import { Lock } from "../lock";
import { Locked } from "../locked";
import { LogOut } from "../log-out";
import { MagnifyingGlass } from "../magnifying-glass";
import { Mail } from "../mail";
import { Manage } from "../manage";
import { MemoPad } from "../memo-pad";
import { Menu } from "../menu";
import { MessageCircle } from "../message-circle";
import { MessageSquare } from "../message-square";
import { MessageXmark } from "../message-xmark";
import { Mic } from "../mic";
import { Minimize2 } from "../minimize2";
import { Minus } from "../minus";
import { MixerHorizontal } from "../mixer-horizontal";
import { Monitor } from "../monitor";
import { MonitorSmartphone } from "../monitor-smartphone";
import { Moon } from "../moon";
import { MoonStars } from "../moon-stars";
import { MoreHorizontal } from "../more-horizontal";
import { MousePointer } from "../mouse-pointer";
import { MoveRight } from "../move-right";
import { Name } from "../name";
import { Navigation } from "../navigation";
import { NextPage } from "../next-page";
import { Note } from "../note";
import { NoteSticky } from "../note-sticky";
import { Null } from "../null";
import { Ol } from "../ol";
import { Paintbrush } from "../paintbrush";
import { PaintBucket } from "../paint-bucket";
import { Palette } from "../palette";
import { PanelLeft } from "../panel-left";
import { PanelLeftClose } from "../panel-left-close";
import { PanelLeftOpen } from "../panel-left-open";
import { PanelRight } from "../panel-right";
import { PanelRightOpen } from "../panel-right-open";
import { PaperPlane } from "../paper-plane";
import { Paragraph } from "../paragraph";
import { Password } from "../password";
import { Pen } from "../pen";
import { PenAlt } from "../pen-alt";
import { PenNib } from "../pen-nib";
import { PersonStanding } from "../person-standing";
import { Phone } from "../phone";
import { Pin } from "../pin";
import { PinOff } from "../pin-off";
import { PinSlash } from "../pin-slash";
import { Play } from "../play";
import { Plus } from "../plus";
import { PreviousPage } from "../previous-page";
import { Pricing } from "../pricing";
import { Printer } from "../printer";
import { Promotion } from "../promotion";
import { Quote } from "../quote";
import { QuoteRight } from "../quote-right";
import { RectangleXmark } from "../rectangle-xmark";
import { Redo } from "../redo";
import { Refresh } from "../refresh";
import { RefreshCcw } from "../refresh-ccw";
import { RefreshCcwDot } from "../refresh-ccw-dot";
import { RefreshCw } from "../refresh-cw";
import { Refused } from "../refused";
import { Reorder } from "../reorder";
import { Restore } from "../restore";
import { RightLong } from "../right-long";
import { RightToBracket } from "../right-to-bracket";
import { Role } from "../role";
import  {RoleSolid} from "../role-solid";
import { Room } from "../room";
import { RotateCcw } from "../rotate-ccw";
import { RotateLeft } from "../rotate-left";
import { RotateRight } from "../rotate-right";
import { SaveNew } from "../save-new";
import { SaveEdit } from "../save-edit";
import { School } from "../school";
import { ScreenShare } from "../screen-share";
import { ScreenUsers } from "../screen-users";
import { Search } from "../search";
import { Select } from "../select";
import { Semester } from "../semester";
import { Sent } from "../sent";
import { Settings } from "../settings";
import { Settings2 } from "../settings2";
import { Shield } from "../shield";
import { ShieldCheck } from "../shield-check";
import { Sidebar } from "../sidebar";
import { SidebarOpen } from "../sidebar-open";
import { Sign } from "../sign";
import { Signed } from "../signed";
import { Site } from "../site";
import { Skill } from "../skill";
import { SkillCategory } from "../skill-category";
import { Slash } from "../slash";
import { SlashForward } from "../slash-forward";
import { SlidersSimple } from "../sliders-simple";
import { Smartphone } from "../smartphone";
import { Sort } from "../sort";
import { SortAsc } from "../sort-asc";
import { SortNumberAsc } from "../sort-number-asc";
import { SortNumberDesc } from "../sort-number-desc";
import { SortOtherAsc } from "../sort-other-asc";
import { SortOtherDesc } from "../sort-other-desc";
import { SortStringAsc } from "../sort-string-asc";
import { SortStringDesc } from "../sort-string-desc";
import { Sparkle } from "../sparkle";
import { Sparkles } from "../sparkles";
import { SpinnerThird } from "../spinner-third";
import { Square } from "../square";
import { SquareArrowOutUpRight } from "../square-arrow-out-up-right";
import { SquareCheck } from "../square-check";
import { SquareDashed } from "../square-dashed";
import { Stats } from "../stats";
import { Strike } from "../strike";
import { Strikethrough } from "../strikethrough";
import { Student } from "../student";
import { Sun } from "../sun";
import { Table } from "../table";
import { TableActions } from "../table-actions";
import { TableList } from "../table-list";
import { TableTree } from "../table-tree";
import { Tag } from "../tag";
import { Teacher } from "../teacher";
import { TeacherNotValidated } from "../teacher-not-validated";
import { TeacherStatus } from "../teacher-status";
import { TeacherStatusSolid } from "../teacher-status-solid";
import { Text } from "../text";
import { TextAlignCenter } from "../text-align-center";
import { TextAlignJustify } from "../text-align-justify";
import { TextAlignLeft } from "../text-align-left";
import { TextAlignRight } from "../text-align-right";
import { TextSlash } from "../text-slash";
import { Ticket } from "../ticket";
import { TicketCheck } from "../ticket-check";
import { TicketX } from "../ticket-x";
import { Time } from "../time";
import { Timeline } from "../timeline";
import { Timer } from "../timer";
import { Times } from "../times";
import { Trash2 } from "../trash2";
import { TrashArrowUp } from "../trash-arrow-up";
import { TrashCan } from "../trash-can";
import { TrashCanList } from "../trash-can-list";
import { TreeCity } from "../tree-city";
import { TreePine } from "../tree-pine";
import { TriangleExclamation } from "../triangle-exclamation";
import { True } from "../true";
import { Type } from "../type";
import { TypeBoolean } from "../type-boolean";
import { TypeCurrency } from "../type-currency";
import { TypeDate } from "../type-date";
import { TypeDateRange } from "../type-date-range";
import { TypeDocumentNumber } from "../type-document-number";
import { TypeEnum } from "../type-enum";
import { TypeList } from "../type-list";
import { TypeName } from "../type-name";
import { TypeNumber } from "../type-number";
import { TypeNumberRange } from "../type-number-range";
import { TypeRelationExists } from "../type-relation-exists";
import { TypeString } from "../type-string";
import { TypeText } from "../type-text";
import { TypeTime } from "../type-time";
import { Ul } from "../ul";
import { Underline } from "../underline";
import { Undo } from "../undo";
import { Unlink2 } from "../unlink2";
import { UnlinkValues } from "../unlink-values";
import { Unpin } from "../unpin";
import { UnsavedChanges } from "../unsaved-changes";
import { User } from "../user";
import { UserHairMullet } from "../user-hair-mullet";
import { Users } from "../users";
import { UsersGear } from "../users-gear";
import { UserTieHair } from "../user-tie-hair";
import { Validated } from "../validated";
import { Video } from "../video";
import { Visible } from "../visible";
import { Warn } from "../warn";
import { X } from "../x";
import { Xmark } from "../xmark";
import { Year } from "../year";
import { Zap } from "../zap";

export const ICON_COMPONENT_BY_NAME_PLACEHOLDERS: Record<string, React.FC<PlaceholderIconProps>> = {
    Accessibility,
    AddressBook,
    Administration,
    AlertCircle,
    Archive,
    ArrowBigUp,
    ArrowDown91,
    ArrowDownUp,
    ArrowDownWideShort,
    ArrowDownZA,
    ArrowLeft,
    ArrowRight,
    ArrowRightFromLine,
    ArrowRotateLeft,
    ArrowRotateRight,
    ArrowUp19,
    ArrowUpArrowDown,
    ArrowUpAZ,
    ArrowUpDown,
    ArrowUpShortWide,
    Badge,
    Ban,
    BarChart,
    BarsStaggered,
    Baseline,
    Bell,
    BellOff,
    Bold,
    Book,
    BookBookmark,
    Bookmark,
    BookOpenCover,
    Books,
    Building2,
    Buildings,
    Calendar,
    CalendarDays,
    Cancel,
    Cancelled,
    CaretSort,
    Cdc,
    CdcCancelled,
    CdcDraft,
    CdcInContract,
    CdcPending,
    CdcSent,
    CdcSigned,
    CdcSignedInContract,
    CdcValidated,
    Certificate,
    ChartSimple,
    Check,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronRightDouble,
    ChevronsLeft,
    ChevronsLeftRight,
    ChevronsRight,
    ChevronUp,
    ChevronUpDouble,
    ChevronLeftDouble,
    ChevronDownDouble,
    Circle,
    CircleCheck,
    CircleCheckBig,
    CircleDashed,
    CircleDot,
    CircleSmall,
    CircleX,
    CircleXmark,
    City,
    ClearStyle,
    Clock,
    Close,
    Cloud,
    CloudArrowUp,
    CloudCheck,
    CloudExclamation,
    Cog,
    Coins,
    Columns,
    CompAlignCenter,
    CompAlignLeft,
    CompAlignRight,
    Contract,
    Copy,
    CornerDownRight,
    Create,
    Crop,
    Cross2,
    Dark,
    Dash,
    Database,
    DeleteMultiple,
    DeleteSingle,
    Description,
    DetailsView,
    DiamondExclamation,
    DisplayModeCalendar,
    DisplayModeGrid,
    DisplayModeList,
    DisplayModeTable,
    DisplayModeTimeline,
    DisplayModeTree,
    DisplayPreferences,
    DollarSign,
    DoorOpen,
    DotFilled,
    Download,
    DragHandle,
    Duration,
    Edit,
    Ellipsis,
    Email,
    Empty,
    EmptySet,
    EnableDrag,
    Envelope,
    Error,
    EuroSign,
    Event,
    EventLocation,
    EventType,
    ExclamationTriangle,
    Expand,
    Eye,
    EyeClosed,
    EyeOff,
    EyeSlash,
    Faculty,
    False,
    Fee,
    File,
    FileContract,
    FileInvoice,
    FileLines,
    FileSignature,
    FileSpreadsheet,
    FileText,
    Filter,
    FilterDelete,
    FilterSlash,
    FirstPage,
    Flag,
    Folder,
    Fullscreen,
    Globe,
    GraduationCap,
    Grid,
    Grid2,
    Grid3x3,
    GripVertical,
    Group,
    Hashtag,
    HelpCircle,
    Highlighter,
    Home,
    HorizontalRule,
    Hourglass,
    HourglassClock,
    Hyphen,
    Image,
    ImageUp,
    InputNumeric,
    Invisible,
    Italic,
    Key,
    Keyboard,
    LastPage,
    LayerGroup,
    Layers,
    Layers2,
    Layers3,
    Layout,
    LayoutTemplate,
    LearningTree,
    LearningUnit,
    Light,
    Link,
    Link2,
    LinkSlash,
    LinkValues,
    List,
    ListFilter,
    ListOl,
    ListTimeline,
    ListTree,
    ListUl,
    Loader2,
    Loading,
    Lock,
    Locked,
    LogOut,
    MagnifyingGlass,
    Mail,
    Manage,
    MemoPad,
    Menu,
    MessageCircle,
    MessageSquare,
    MessageXmark,
    Mic,
    Minimize2,
    Minus,
    MixerHorizontal,
    Monitor,
    MonitorSmartphone,
    Moon,
    MoonStars,
    MoreHorizontal,
    MousePointer,
    MoveRight,
    Name,
    Navigation,
    NextPage,
    Note,
    NoteSticky,
    Null,
    Ol,
    Paintbrush,
    PaintBucket,
    Palette,
    PanelLeft,
    PanelLeftClose,
    PanelLeftOpen,
    PanelRight,
    PanelRightOpen,
    PaperPlane,
    Paragraph,
    Password,
    Pen,
    PenAlt,
    PenNib,
    PersonStanding,
    Phone,
    Pin,
    PinOff,
    PinSlash,
    Play,
    Plus,
    PreviousPage,
    Pricing,
    Printer,
    Promotion,
    Quote,
    QuoteRight,
    RectangleXmark,
    Redo,
    Refresh,
    RefreshCcw,
    RefreshCcwDot,
    RefreshCw,
    Refused,
    Reorder,
    Restore,
    RightLong,
    RightToBracket,
    Role,
    RoleSolid,
    Room,
    RotateCcw,
    RotateLeft,
    RotateRight,
    SaveNew,
    SaveEdit,
    School,
    ScreenShare,
    ScreenUsers,
    Search,
    Select,
    Semester,
    Sent,
    Settings,
    Settings2,
    Shield,
    ShieldCheck,
    Sidebar,
    SidebarOpen,
    Sign,
    Signed,
    Site,
    Skill,
    SkillCategory,
    Slash,
    SlashForward,
    SlidersSimple,
    Smartphone,
    Sort,
    SortAsc,
    SortNumberAsc,
    SortNumberDesc,
    SortOtherAsc,
    SortOtherDesc,
    SortStringAsc,
    SortStringDesc,
    Sparkle,
    Sparkles,
    SpinnerThird,
    Square,
    SquareArrowOutUpRight,
    SquareCheck,
    SquareDashed,
    Stats,
    Strike,
    Strikethrough,
    Student,
    Sun,
    Table,
    TableActions,
    TableList,
    TableTree,
    Tag,
    Teacher,
    TeacherNotValidated,
    TeacherStatus,
    TeacherStatusSolid,
    Text,
    TextAlignCenter,
    TextAlignJustify,
    TextAlignLeft,
    TextAlignRight,
    TextSlash,
    Ticket,
    TicketCheck,
    TicketX,
    Time,
    Timeline,
    Timer,
    Times,
    Trash2,
    TrashArrowUp,
    TrashCan,
    TrashCanList,
    TreeCity,
    TreePine,
    TriangleExclamation,
    True,
    Type,
    TypeBoolean,
    TypeCurrency,
    TypeDate,
    TypeDateRange,
    TypeDocumentNumber,
    TypeEnum,
    TypeList,
    TypeName,
    TypeNumber,
    TypeNumberRange,
    TypeRelationExists,
    TypeString,
    TypeText,
    TypeTime,
    Ul,
    Underline,
    Undo,
    Unlink2,
    UnlinkValues,
    Unpin,
    UnsavedChanges,
    User,
    UserHairMullet,
    Users,
    UsersGear,
    UserTieHair,
    Validated,
    Video,
    Visible,
    Warn,
    X,
    Xmark,
    Year,
    Zap,
};
